import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { FormsModule} from "@angular/forms"

import { AppComponent } from './app.component';
import { ChatComponent } from './components/chat/chat.component';
import {ChatService} from "./providers/chat.service";
import { LoginComponent } from './components/login/login.component'

@NgModule({
  declarations: [
    AppComponent,
    ChatComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
     AngularFireModule.initializeApp(environment.firebase),
      AngularFirestoreModule,
    AngularFireAuthModule,FormsModule
  ],
  providers: [ChatService],
  bootstrap: [AppComponent]
})
export class AppModule { }
